//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @param studyId (optional) 
 * @param search (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function getParticipants(studyId?: number | undefined, search?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PagedResultOfParticipantDto> {
    let url_ = getBaseUrl() + "/api/Participants?";
    if (studyId === null)
        throw new Error("The parameter 'studyId' cannot be null.");
    else if (studyId !== undefined)
        url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
    if (search !== undefined && search !== null)
        url_ += "Search=" + encodeURIComponent("" + search) + "&";
    if (offset !== undefined && offset !== null)
        url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
    if (limit !== undefined && limit !== null)
        url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
    if (sortBy !== undefined && sortBy !== null)
        url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
    if (sortOrder === null)
        throw new Error("The parameter 'sortOrder' cannot be null.");
    else if (sortOrder !== undefined)
        url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetParticipants,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetParticipants(_response);
    });
}

function processGetParticipants(response: AxiosResponse): Promise<Types.PagedResultOfParticipantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.PagedResultOfParticipantDto.fromJS(resultData200);
        return Promise.resolve<Types.PagedResultOfParticipantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PagedResultOfParticipantDto>(null as any);
}

export function createParticipant(attachments?: Types.FileParameter[] | null | undefined, requestDto?: Types.CreateParticipantsRequestDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ParticipantDto> {
    let url_ = getBaseUrl() + "/api/Participants";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (attachments !== null && attachments !== undefined)
        attachments.forEach(item_ => content_.append("attachments", item_.data, item_.fileName ? item_.fileName : "attachments") );
    if (requestDto === null || requestDto === undefined)
        throw new Error("The parameter 'requestDto' cannot be null.");
    else
        content_.append("requestDto", JSON.stringify(requestDto));

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateParticipant,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateParticipant(_response);
    });
}

function processCreateParticipant(response: AxiosResponse): Promise<Types.ParticipantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ParticipantDto.fromJS(resultData200);
        return Promise.resolve<Types.ParticipantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ParticipantDto>(null as any);
}

export function updateParticipant(id: string, attachments?: Types.FileParameter[] | null | undefined, requestDto?: Types.UpdateParticipantRequestDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ParticipantDto> {
    let url_ = getBaseUrl() + "/api/Participants/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = new FormData();
    if (attachments !== null && attachments !== undefined)
        attachments.forEach(item_ => content_.append("attachments", item_.data, item_.fileName ? item_.fileName : "attachments") );
    if (requestDto === null || requestDto === undefined)
        throw new Error("The parameter 'requestDto' cannot be null.");
    else
        content_.append("requestDto", JSON.stringify(requestDto));

    let options_: AxiosRequestConfig = {
        ..._requestConfigUpdateParticipant,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            "Accept": "application/json"
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processUpdateParticipant(_response);
    });
}

function processUpdateParticipant(response: AxiosResponse): Promise<Types.ParticipantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.ParticipantDto.fromJS(resultData200);
        return Promise.resolve<Types.ParticipantDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ParticipantDto>(null as any);
}

export function deleteParticipant(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/Participants/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteParticipant,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteParticipant(_response);
    });
}

function processDeleteParticipant(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.ValidationProblemDetails.fromJS(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigGetParticipants: Partial<AxiosRequestConfig> | null;
export function getGetParticipantsRequestConfig() {
  return _requestConfigGetParticipants;
}
export function setGetParticipantsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetParticipants = value;
}
export function patchGetParticipantsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetParticipants = patch(_requestConfigGetParticipants ?? {});
}

let _requestConfigCreateParticipant: Partial<AxiosRequestConfig> | null;
export function getCreateParticipantRequestConfig() {
  return _requestConfigCreateParticipant;
}
export function setCreateParticipantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateParticipant = value;
}
export function patchCreateParticipantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateParticipant = patch(_requestConfigCreateParticipant ?? {});
}

let _requestConfigUpdateParticipant: Partial<AxiosRequestConfig> | null;
export function getUpdateParticipantRequestConfig() {
  return _requestConfigUpdateParticipant;
}
export function setUpdateParticipantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigUpdateParticipant = value;
}
export function patchUpdateParticipantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigUpdateParticipant = patch(_requestConfigUpdateParticipant ?? {});
}

let _requestConfigDeleteParticipant: Partial<AxiosRequestConfig> | null;
export function getDeleteParticipantRequestConfig() {
  return _requestConfigDeleteParticipant;
}
export function setDeleteParticipantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteParticipant = value;
}
export function patchDeleteParticipantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteParticipant = patch(_requestConfigDeleteParticipant ?? {});
}